import { render, staticRenderFns } from "./invest_qrcode.vue?vue&type=template&id=f6c35984&scoped=true"
import script from "./invest_qrcode.vue?vue&type=script&lang=js"
export * from "./invest_qrcode.vue?vue&type=script&lang=js"
import style0 from "./invest_qrcode.vue?vue&type=style&index=0&id=f6c35984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c35984",
  null
  
)

export default component.exports